







import { genVuexComputeds } from '@/main/pages/editFactory';
import { EditStoreMixin } from '@/main/pages/editStoreMixin';

import { NAME } from './constants';
import { store } from '../../store/edit';


export default EditStoreMixin.extend({
	name: 'ZapujckyCard',
	data() {
		return {
			NAME,
		};
	},
	computed: {
		...genVuexComputeds(store),
		planSkutecnost() {
			return NAME;
		},
	},
});
